module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "id": "piv"
    }
  }), _vm._v(" Copyright © 1976 by Amos Oz and Am Oved Publishers Ltd."), _c('br'), _vm._v("\nEnglish translation copyright © 1976 by Amos Oz")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced or transmitted in any form or by any means, electronic or mechanical, including photocopy, recording, or any information storage and retrieval system, without permission in writing from the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("For information about permission to reproduce selections from this book, write to Permissions, Houghton Mifflin Harcourt Publishing Company, 215 Park Avenue South, New York, New York 10003.")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "http://www.hmhco.com/popular-reading",
      "target": "_blank"
    }
  }, [_vm._v("www.hmhco.com")])]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("The Library of Congress has cataloged the print edition as follows:"), _c('br'), _vm._v("\nOz, Amos."), _c('br'), _vm._v("\nThe hill of evil counsel."), _c('br'), _vm._v("\n\"A Helen and Kuit Wolff book.\""), _c('br'), _vm._v("\nTranslation of Har ha-'estsah ha-rah 'ah."), _c('br'), _vm._v("\nCONTENTS: The hill of evil counsel.—Mr. Levi."), _c('br'), _vm._v("\n—Longing"), _c('br'), _vm._v("\nI. Title."), _c('br'), _vm._v("\nPZ4.0989HI [PJ5054] 892.4'3'6 77-92543"), _c('br'), _vm._v("\nISBN 978-0-15-640275-0 (pbk.)")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("eISBN 978-0-547-56388-6"), _c('br'), _vm._v("\nv2.1213")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1152e084","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front01.vue
// module id = 60
// module chunks = 0